import { useEffect, useState, useRef } from 'react'
import { Route, useHistory } from 'react-router-dom'
import Cookies from 'js-cookie'
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'
import { setLoginRoleAndVerify as basicSet, setLoginToken as basicSetToken } from 'actions/basic/actions'
import { setLoginRoleAndVerify as specialSet, setLoginToken as specialSetToken } from 'actions/special/actions'
import { setLoginRoleAndVerify as individualSet, setLoginToken as individualSetToken } from 'actions/individual/actions'

function PrivateRoute({ Component, cate, check_role, ...rest }) {
  const role = useSelector((s) => s.login.role)
  const token = useSelector((s) => s.login.token)
  let authed = token !== '' && role === check_role

  return (
    <Route
      {...rest}
      render={(props) => (authed ? <Component {...props} /> : <Auth cate={cate} check_role={check_role} />)}
    />
  )
}

export default PrivateRoute

function getHomePath(cate) {
  if (cate === 'special') return '/special'
  if (cate === 'individual') return '/individual'
  return '/basic'
}

function getSetLoginRole(cate) {
  if (cate === 'special') return specialSet
  if (cate === 'individual') return individualSet
  return basicSet
}

function getSetLoginToken(cate) {
  if (cate === 'special') return specialSetToken
  if (cate === 'individual') return individualSetToken
  return basicSetToken
}

function Auth({ cate, check_role }) {
  const role = useSelector((s) => s.login.role)
  const token = useSelector((s) => s.login.token)
  const access = useSelector((s) => s.login.access)
  const dispatch = useDispatch()
  const history = useHistory()
  const [message, setMessage] = useState('認證中...')
  const attemptedRef = useRef(false)

  let tokenKey
  if (cate === 'basic') tokenKey = 'basic_token'
  else if (cate === 'special') tokenKey = 'special_token'
  else if (cate === 'individual') tokenKey = 'individual_token'
  const tokenFromCookie = Cookies.get('token') || (tokenKey ? Cookies.get(tokenKey) : undefined)

  useEffect(() => {
    if (attemptedRef.current) return

    const denyAccess = () => {
      setMessage('無權限，即將返回首頁...')
      alert('你沒有權限')
      history.push(getHomePath(cate))
    }
    console.log('token', token)
    console.log('tokenFromCookie', tokenFromCookie)
    console.log('access', access)
    console.log('check_role', check_role)
    console.log('cate', cate)
    console.log('dispatch', dispatch)
    console.log('history', history)
    console.log('attemptedRef', attemptedRef.current)
    console.log('message', message)
    if (!token && !tokenFromCookie) {
      attemptedRef.current = true
      setMessage('跳轉登入頁面...')
      goLogin(check_role, cate)
      return
    }

    if (access[check_role] === false) {
      attemptedRef.current = true
      denyAccess()
      return
    }

    if (token && role === check_role) return

    attemptedRef.current = true
    const tokenToUse = token || tokenFromCookie

    if (!check_role) {
      dispatch(getSetLoginToken(cate)(tokenToUse))
      return
    }

    axios
      .get(`/en/${cate}/api/tokenChecknValidation/${tokenToUse}/${check_role}`)
      .then((res) => {
        if (res.data.status === 'OK') {
          dispatch(getSetLoginRole(cate)(check_role, tokenToUse))
        } else {
          denyAccess()
        }
      })
      .catch(() => {
        denyAccess()
      })
  }, [token, role, tokenFromCookie, access, check_role, cate, dispatch, history])

  return <div>{message}</div>
}

function goLogin(role, cate) {
  let c = '/basic'
  if (cate === 'special') c = '/special'
  else if (cate === 'individual') c = '/individual'

  if (process.env.NODE_ENV === 'production')
    window.location.href = `${process.env.REACT_APP_BACKEND_API}/en${c}/api/signin/${role}?to=${
      window.location.href.split(/[?#]/)[0]
    }?role=${role}`
  else
    alert(
      `redirect to: ${process.env.REACT_APP_BACKEND_API}/en${c}/api/signin/${role}?to=${
        window.location.href.split(/[?#]/)[0]
      }?role=${role}`
    )
}
